import background from './background'
import header     from './backgrounds/header-bg.png'
import icon       from './icon'
import icons      from './icons'
import logo       from './logo'
import profile    from './avatars/profile.jpg'
import texture    from './textures/project-paper.png'

const index =
{
    background,
    header,
    icon,
    icons,
    logo,
    profile,
    texture
} ;

export default index ;